module.exports = __webpack_public_path__ + "img/自定义标签.ed7cb6d8.svg";